import React, { useCallback, useMemo } from 'react'
import { take } from 'lib/array/arrayUtils'
import { pluralizeToString } from 'lib/string/pluralize'
import CategoryTile from 'components/Luxkit/CategoryTile'
import useTrackExperienceOfferEvent from 'contexts/support/useTrackExperienceOfferEvent'

const parentCategoryChildText: Record<number, string> = {
  // Wine & dining
  1: 'Fine dining, restaurant & bars, food tours, wine country trips and more.',
  // Top activities
  9: 'Hot air ballooning, watersports, cruises, photoshoots and more.',
  // Indulge yourself
  31: 'Spa & massage, hot springs, wellness and more.',
  // Attractions & tickets
  18: 'Theme & water parks, museums, galleries, zoos, historical sites and more.',
  // Live events
  27: 'Concerts, theatre, live sports and more.',
  // Airport lounges
  35: 'Relax at the airport lounge, book a transfer and more.',
  // Lux exclusive
  40: 'The best of the best.',
  // Day tours
  48: 'Guided tours, private tours, hop-on-hop-off buses, walking tours and more.',
}

interface Props {
  category: App.ExperienceItemCategory;
  count: number;
  childCategories: Array<App.ExperienceItemCategory>;
  to: string;
}

function ExperiencesPageCategoryTile(props: Props) {
  const { category, to, childCategories, count } = props
  const trackEvent = useTrackExperienceOfferEvent()

  const subCategories = useMemo(() =>
    parentCategoryChildText[category.id] ?? (take(childCategories, 4).map(cat => cat.name).join(', ') + ' and more')
  , [childCategories, category])

  const image = useMemo((): App.Image => ({
    id: category.imageId,
    title: category.name,
  }), [category])

  // eslint-disable-next-line react-hooks/exhaustive-deps -- trackEvent is stable
  const handleClick = useCallback(() => trackEvent('CATEGORY_CLICKED'), [])

  return <CategoryTile
    onClick={handleClick}
    to={to}
    image={image}
    heading={category.name}
    subHeading={subCategories}
    align="top"
    callToAction={`View ${pluralizeToString('offer', count)}`}
  />
}

export default ExperiencesPageCategoryTile
